import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Zap, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/8 mt-32">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-gradient-to-br from-[#d4af37] to-[#a3852c]">
              <Zap className="w-4 h-4 text-[#0a0b0e]" strokeWidth={3} />
            </div>
            <span className="font-display font-semibold text-white text-lg">LoftPress</span>
          </Link>
          <p className="text-white/50 text-sm max-w-xs">{t("footer.tagline")}</p>
          <div className="flex items-center gap-3 mt-6">
            <a href="mailto:support@loftpress.shop" className="text-white/50 hover:text-[#d4af37] text-sm inline-flex items-center gap-1.5" data-testid="footer-email">
              <Mail className="w-3.5 h-3.5" /> support@loftpress.shop
            </a>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-4">{t("footer.product")}</div>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/marketplace" className="hover:text-white">{t("nav.marketplace")}</Link></li>
            <li><Link to="/docs" className="hover:text-white">{t("nav.docs")}</Link></li>
            <li><Link to="/status" className="hover:text-white">{t("footer.status")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-4">{t("footer.legal")}</div>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/legal/terms" className="hover:text-white" data-testid="footer-terms">{t("footer.terms")}</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-white" data-testid="footer-privacy">{t("footer.privacy")}</Link></li>
            <li><Link to="/legal/aup" className="hover:text-white" data-testid="footer-aup">{t("footer.aup")}</Link></li>
            <li><Link to="/legal/refund" className="hover:text-white" data-testid="footer-refund">{t("footer.refund")}</Link></li>
            <li><Link to="/legal/cookies#preferences" className="hover:text-white" data-testid="footer-cookie-prefs">{t("footer.cookie_prefs")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-4">{t("footer.company")}</div>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/legal/contact" className="hover:text-white" data-testid="footer-contact">{t("footer.contact")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/6 py-6 px-6 text-center text-xs text-white/40 font-mono space-y-1">
        <div>© {new Date().getFullYear()} LoftPress. {t("footer.copyright")} loftpress.shop</div>
        <div data-testid="footer-company-line">
          LOFT PRESS LTD · Companies House no. 16676296 · Unit 501 Leroy House, 434-436 Essex Road, London, N1 3FY
        </div>
      </div>
    </footer>
  );
}
